import React, { ReactElement } from 'react'
import { RecipeModal } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModal'
import { RecipeWithQuantity } from '@mindfulchefuk/features/Recipes/interfaces'

export type TRecipeModalWithCTAs = {
  isWithinOrderWindow?: boolean
  maximumRecipes: number
  onIncrement: (
    recipe: RecipeWithQuantity,
    isRecipeRecommended: boolean
  ) => void
  onDecrement: (recipe: RecipeWithQuantity) => void
  recipe: RecipeWithQuantity
  totalRecipesInCart: number
  withCookingInstructions?: boolean
}

export const RecipeModalWithCTAs = ({
  isWithinOrderWindow = true,
  maximumRecipes,
  onIncrement,
  onDecrement,
  recipe,
  totalRecipesInCart,
  withCookingInstructions,
}: TRecipeModalWithCTAs): ReactElement => (
  <RecipeModal
    isAdditionDisabled={totalRecipesInCart === maximumRecipes}
    isWithinOrderWindow={isWithinOrderWindow}
    onDecrement={onDecrement}
    onIncrement={onIncrement}
    recipe={recipe}
    withCookingInstructions={withCookingInstructions}
  />
)
